var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Property, ChildProperty, Complex } from '@syncfusion/ej2-base';
import { Theme } from '../model/theme';
/**
 * Sets and gets the options to customize the styles of the borders in circular gauge.
 */
export class Border extends ChildProperty {
}
__decorate([
    Property('')
], Border.prototype, "color", void 0);
__decorate([
    Property(1)
], Border.prototype, "width", void 0);
__decorate([
    Property('')
], Border.prototype, "dashArray", void 0);
/**
 * Sets and gets the font style for the circular gauge.
 */
export class Font extends ChildProperty {
}
__decorate([
    Property('16px')
], Font.prototype, "size", void 0);
__decorate([
    Property('')
], Font.prototype, "color", void 0);
__decorate([
    Property('segoe UI')
], Font.prototype, "fontFamily", void 0);
__decorate([
    Property('Normal')
], Font.prototype, "fontWeight", void 0);
__decorate([
    Property('Normal')
], Font.prototype, "fontStyle", void 0);
__decorate([
    Property(1)
], Font.prototype, "opacity", void 0);
/**
 * Sets and gets the options to customize the tooltip properties for range tooltip.
 */
export class RangeTooltip extends ChildProperty {
}
__decorate([
    Property(null)
], RangeTooltip.prototype, "fill", void 0);
__decorate([
    Complex({ size: null, fontFamily: null, opacity: null, fontWeight: null }, Font)
], RangeTooltip.prototype, "textStyle", void 0);
__decorate([
    Property(null)
], RangeTooltip.prototype, "format", void 0);
__decorate([
    Property(null)
], RangeTooltip.prototype, "template", void 0);
__decorate([
    Property(true)
], RangeTooltip.prototype, "enableAnimation", void 0);
__decorate([
    Complex({ color: null }, Border)
], RangeTooltip.prototype, "border", void 0);
__decorate([
    Property(false)
], RangeTooltip.prototype, "showAtMousePosition", void 0);
/**
 * Sets and gets the options to customize the tooltip for annotation in circular gauge.
 */
export class AnnotationTooltip extends ChildProperty {
}
__decorate([
    Property(null)
], AnnotationTooltip.prototype, "fill", void 0);
__decorate([
    Complex({ size: '13px', fontFamily: null, opacity: null }, Font)
], AnnotationTooltip.prototype, "textStyle", void 0);
__decorate([
    Property(null)
], AnnotationTooltip.prototype, "format", void 0);
__decorate([
    Property(null)
], AnnotationTooltip.prototype, "template", void 0);
__decorate([
    Property(true)
], AnnotationTooltip.prototype, "enableAnimation", void 0);
__decorate([
    Complex({ color: null }, Border)
], AnnotationTooltip.prototype, "border", void 0);
/**
 * Sets and gets the margin of circular gauge.
 */
export class Margin extends ChildProperty {
}
__decorate([
    Property(10)
], Margin.prototype, "left", void 0);
__decorate([
    Property(10)
], Margin.prototype, "right", void 0);
__decorate([
    Property(10)
], Margin.prototype, "top", void 0);
__decorate([
    Property(10)
], Margin.prototype, "bottom", void 0);
/**
 * Sets and gets the options to customize the tooltip of the circular gauge.
 */
export class TooltipSettings extends ChildProperty {
}
__decorate([
    Property(false)
], TooltipSettings.prototype, "enable", void 0);
__decorate([
    Property(null)
], TooltipSettings.prototype, "fill", void 0);
__decorate([
    Complex({ size: null, fontFamily: null, opacity: null, fontWeight: null }, Font)
], TooltipSettings.prototype, "textStyle", void 0);
__decorate([
    Complex({}, RangeTooltip)
], TooltipSettings.prototype, "rangeSettings", void 0);
__decorate([
    Complex({}, AnnotationTooltip)
], TooltipSettings.prototype, "annotationSettings", void 0);
__decorate([
    Property(null)
], TooltipSettings.prototype, "format", void 0);
__decorate([
    Property(null)
], TooltipSettings.prototype, "template", void 0);
__decorate([
    Property(true)
], TooltipSettings.prototype, "enableAnimation", void 0);
__decorate([
    Complex({ color: null }, Border)
], TooltipSettings.prototype, "border", void 0);
__decorate([
    Property(false)
], TooltipSettings.prototype, "showAtMousePosition", void 0);
__decorate([
    Property('Pointer')
], TooltipSettings.prototype, "type", void 0);
/**
 * Sets and gets the location of the legend in circular gauge.
 */
export class Location extends ChildProperty {
}
__decorate([
    Property(0)
], Location.prototype, "x", void 0);
__decorate([
    Property(0)
], Location.prototype, "y", void 0);
/**
 * Sets and gets the options to customize the legend for the ranges in the circular gauge.
 */
export class LegendSettings extends ChildProperty {
}
__decorate([
    Property(false)
], LegendSettings.prototype, "visible", void 0);
__decorate([
    Property(true)
], LegendSettings.prototype, "toggleVisibility", void 0);
__decorate([
    Property('Center')
], LegendSettings.prototype, "alignment", void 0);
__decorate([
    Complex({}, Border)
], LegendSettings.prototype, "border", void 0);
__decorate([
    Complex({}, Border)
], LegendSettings.prototype, "shapeBorder", void 0);
__decorate([
    Property(8)
], LegendSettings.prototype, "padding", void 0);
__decorate([
    Property(1)
], LegendSettings.prototype, "opacity", void 0);
__decorate([
    Property('Auto')
], LegendSettings.prototype, "position", void 0);
__decorate([
    Property('Circle')
], LegendSettings.prototype, "shape", void 0);
__decorate([
    Property(null)
], LegendSettings.prototype, "height", void 0);
__decorate([
    Property(null)
], LegendSettings.prototype, "width", void 0);
__decorate([
    Complex(Theme.legendLabelFont, Font)
], LegendSettings.prototype, "textStyle", void 0);
__decorate([
    Property(10)
], LegendSettings.prototype, "shapeHeight", void 0);
__decorate([
    Property(10)
], LegendSettings.prototype, "shapeWidth", void 0);
__decorate([
    Property(5)
], LegendSettings.prototype, "shapePadding", void 0);
__decorate([
    Complex({ x: 0, y: 0 }, Location)
], LegendSettings.prototype, "location", void 0);
__decorate([
    Property('transparent')
], LegendSettings.prototype, "background", void 0);
__decorate([
    Complex({ left: 0, right: 0, top: 0, bottom: 0 }, Margin)
], LegendSettings.prototype, "margin", void 0);
